
import { Options, Vue } from 'vue-class-component';
import { mapGetters } from 'vuex';

const STORAGE_KEY = 'jumbada_age_verified';

@Options({
  computed: {
    ...mapGetters(['getJsonData']),
    jsonData() {
      const jsonData = (this as any).getJsonData;
      const jsonDataWithBreaks = JSON.stringify(jsonData).replace(/\\n/g, '<br>');
      return JSON.parse(jsonDataWithBreaks);
    }
  },
  data() {
    return {
      visible: false
    };
  },
  mounted() {
    if (localStorage.getItem(STORAGE_KEY) !== '1') {
      (this as any).visible = true;
      document.body.style.overflow = 'hidden';
    }
  },
  methods: {
    confirm() {
      localStorage.setItem(STORAGE_KEY, '1');
      (this as any).visible = false;
      document.body.style.removeProperty('overflow');
    },
    decline() {
      window.location.href = 'https://www.google.com';
    }
  }
})
export default class AgeGate extends Vue {}
